import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import ProcessUiComponent from '@iupics-components/specific/window/process-ui/process-ui.component';
import { WindowFactoryUtils } from '@iupics-manager/managers/ui-creator/window-factory/window-factory-utils';
import { AbstractDynamicComponent } from '@iupics-manager/models/abstract-dynamic-component';
import { Global } from '@iupics-manager/models/global-var';
import { IupicsEvent } from '@iupics-manager/models/iupics-event';
import { timer } from 'rxjs';
import { DynamicContainerDirective } from '../../../../iupics-util/directives/dynamic-container.directive';

@Component({
  selector: 'div[iu-grid-ui]',
  templateUrl: './grid-ui.component.html',
  styleUrls: ['./grid-ui.component.css'],
  standalone: true,
  imports: [DynamicContainerDirective],
  host: {
    '[class]': 'cssClass',
    '[style.--blade-nb-cols]': 'parentProcess?.nbCol() ?? undefined',
    '[class.empty-grid]': 'isEmpty',
  },
})
export default class GridUiComponent extends AbstractDynamicComponent implements OnInit, AfterViewInit {
  @Input() cssClass: string | undefined;

  protected isEmpty = false;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    if (!this.cssClass || Global.isMobileWidth()) {
      this.cssClass = 'p-col-12 p-col-nopad';
    }
    Global.startPerf(this);
  }

  ngAfterViewInit(): void {
    if (this.DOMParentComponent instanceof ProcessUiComponent) {
      this.parentProcess = this.DOMParentComponent;
    }
    this.buildChildren();
  }

  buildChildren(): void {
    if (!this.children.length) {
      this.isEmpty = true;
      return;
    }
    const firstChild = this.children[0];
    if (firstChild && firstChild.data?.tabLevel === 0 && firstChild.component === 'EditTabUiComponent') {
      WindowFactoryUtils.addContainerComponent({
        parent: this,
        item: firstChild,
        isCssOnComponent: firstChild.container ? firstChild.isCssOnComponent : false,
      });
      this.cd.detectChanges();
      this.subscriptions.push(
        timer(0).subscribe(() => {
          for (let i = 1; i < this.children.length; i++) {
            const child = this.children[i];
            WindowFactoryUtils.addContainerComponent({
              parent: this,
              item: child,
              isCssOnComponent: child.container ? child.isCssOnComponent : false,
            });
          }
        })
      );
    } else {
      for (const child of this.children) {
        WindowFactoryUtils.addContainerComponent({
          parent: this,
          item: child,
          isCssOnComponent: child.container ? child.isCssOnComponent : false,
        });
      }
    }
  }
  onChildUpdate(event): void {}

  onSiblingUpdate(event: IupicsEvent) {}

  onRemoveComponent(event: IupicsEvent) {}
}
